// hooks/useUserProjects.js
import { useEffect, useState } from "react";
import serverURL from "../config/serverConfig";

const useUserProjects = (user_id) => {
    const [userProjects, setUserProjects] = useState();

    useEffect(() => {
        if (!user_id) return;

        fetch(`${serverURL}getUserProjects`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setUserProjects(jsonData);
            })
            .catch(error => {
                console.error("Error fetching projects:", error);
            });

    }, [user_id]);
    return userProjects;
};

const useUserClients = (user_id) => {
    const [userClients, setUserClients] = useState();

    // temp data
    // const userClients = ([
    //     {
    //         client_id: 1,
    //         name: "Client A",
    //         email: "email@email.com",
    //         phone: "123-456-7890",
    //         projects: [
    //             { project_id: 1 },
    //             { project_id: 2 },
    //         ],
    //     },
    //     {
    //         client_id: 2,
    //         name: "Client B",
    //         email: "email@email.com",
    //         phone: "123-456-7890",
    //         projects: [
    //             { project_id: 3},
    //             { project_id: 4 },
    //         ],
    //     },
    // ])

    useEffect(() => {
        if (!user_id) return;

        fetch(`${serverURL}getUserClients`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setUserClients(jsonData);
            })
            .catch(error => {
                console.error("Error fetching clients:", error);
            });

    }, [user_id]);
    return userClients;
};

const useSingleProject = (project_id) => {
    const [project, setProject] = useState();

    useEffect(() => {
        if (!project_id) return;
        console.log("Fetching project with ID:", project_id);
        fetch(`${serverURL}getProject`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ project_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                setProject(jsonData);
            })
            .catch(error => {
                console.error("Error fetching project:", error);
            });

    }, [project_id]);
    return project;
}

// Function to update a single project
const updateSingleProject = async (project_id, updatedData) => {
    if (!project_id || !updatedData) return;

    try {
        const response = await fetch(`${serverURL}updateProject`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                detail: updatedData,
            }),
        });

        const jsonData = await response.json();
        console.log("Project updated:", jsonData);
    } catch (error) {
        console.error("Error updating project:", error);
    }
};

// fetch projects from single client
const useClientProjects = (client_id) => {
    const [clientProjects, setClientProjects] = useState();

    useEffect(() => {
        if (!client_id) return;

        fetch(`${serverURL}getClientProjects`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ client_id }),
        })
            .then(response => response.json())
            .then(jsonData => {
                console.log("Fetched client projects:", jsonData);
                setClientProjects(jsonData);
            })
            .catch(error => {
                console.error("Error fetching client projects:", error);
            });
            
    }, [client_id]);
    return clientProjects;
};

export { useUserProjects, useUserClients, useSingleProject, updateSingleProject, useClientProjects  };